'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataObject = require('./data-object');

var _dataObject2 = _interopRequireDefault(_dataObject);

var _product = require('./product');

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

var Transaction = function (_DataObject) {
    (0, _inherits3.default)(Transaction, _DataObject);
    (0, _createClass3.default)(Transaction, null, [{
        key: 'ID',
        get: function get() {
            return 'id';
        } // Transaction id

    }, {
        key: 'AFFILIATION',
        get: function get() {
            return 'affiliation';
        } // Checkout Method (Web, Paypal, Apple Pay, Google store ... etc)

    }, {
        key: 'REVENUE',
        get: function get() {
            return 'revenue';
        } // Grand total (including shipping and taxes)

    }, {
        key: 'TAX',
        get: function get() {
            return 'tax';
        }
    }, {
        key: 'SHIPPING',
        get: function get() {
            return 'shipping';
        }
    }, {
        key: 'LIST',
        get: function get() {
            return 'list';
        } // Purchase attribution - What affected this purchase? (ie. Web push)

    }, {
        key: 'STEP',
        get: function get() {
            return 'step';
        } // A number representing a step in the checkout process

    }, {
        key: 'OPTION',
        get: function get() {
            return 'option';
        } // Additional options

    }]);

    function Transaction(transactionInfo, productsInfo, additionalTransactionRequiredFields, additionalProductRequiredFields, transactionKeyMap, productKeyMap) {
        var _ret;

        var keepExtraFields = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
        (0, _classCallCheck3.default)(this, Transaction);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Transaction.__proto__ || (0, _getPrototypeOf2.default)(Transaction)).call(this, [Transaction.ID], [Transaction.AFFILIATION, Transaction.REVENUE, Transaction.TAX, Transaction.SHIPPING, Transaction.LIST, Transaction.STEP, Transaction.OPTION], transactionInfo, keepExtraFields));

        _this.isValid(additionalTransactionRequiredFields, transactionKeyMap);

        _this.sanitizeMoney(Transaction.REVENUE);
        _this.sanitizeMoney(Transaction.TAX);
        _this.sanitizeMoney(Transaction.SHIPPING);

        _this.products = [];
        productsInfo.forEach(function (product) {
            _this.products.push(new _product2.default(product, additionalProductRequiredFields, productKeyMap, keepExtraFields));
        });

        return _ret = _this.build(transactionKeyMap), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Transaction, [{
        key: 'build',
        value: function build(keyMap) {
            return {
                transaction: (0, _get3.default)(Transaction.prototype.__proto__ || (0, _getPrototypeOf2.default)(Transaction.prototype), 'build', this).call(this, keyMap),
                products: this.products
            };
        }
    }]);
    return Transaction;
}(_dataObject2.default);

exports.default = Transaction;


//////////////////
// WEBPACK FOOTER
// ./~/progressive-web-sdk/dist/analytics/data-objects/transaction.js
// module id = 130
// module chunks = 0